module.exports = __webpack_public_path__ + "img/paypal.7155ad7b1c751c2077f41202953814df.svg";